/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import MeatballToggle from './MeatballToggle';
import generateDropdown from '../generateDropdown';

export default generateDropdown(MeatballToggle, { useToggleForPopover: true });
